<div class="container-fluid py-4">
  <div class="py-4">
    <div class="d-inline-block align-middle me-3">
      <svg-icon src="assets/icons/icon-privacy.svg"> </svg-icon>
    </div>
    <h1 class="d-inline-block align-middle m-0">{{ 'TERMS_TITLE' | translate }}</h1>
  </div>
  <ul ngbNav #nav="ngbNav" class="nav-tabs">
    <li ngbNavItem>
      <a ngbNavLink>
        {{ 'PRIVACY_POLICY_TAB' | translate }}
      </a>

      <ng-template ngbNavContent>
        <app-privacy></app-privacy>
      </ng-template>
    </li>

    <li ngbNavItem>
      <a ngbNavLink>
        {{ 'TERMS_OF_USE_TAB' | translate }}
      </a>

      <ng-template ngbNavContent>
        <app-terms-of-use></app-terms-of-use>
      </ng-template>
    </li>

    <li ngbNavItem>
      <a ngbNavLink>
        {{ 'GLOBAL_SECURITY_TAB' | translate }}
      </a>

      <ng-template ngbNavContent>
        <app-global-counsel></app-global-counsel>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
